import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
//import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Solveny extends Component {
    constructor(props){     
        super(props);   
        this.state = {
          errors: {},
          banklist: [], 
          details:{}
         }  
        this.handleChange = this.handleChange.bind(this);  
        this.selecthandleChange = this.selecthandleChange.bind(this);  
        this.datepickerhandleChange = this.datepickerhandleChange.bind(this); 
      }    
    componentDidMount() {
        document.title = "Solvency Details"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');  
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;   
        if(this.props.children){
            Axios.get(`${process.env.REACT_APP_API_URL}contractor/contractorsolvency/agencyid/`+this.props.children)
          .then(result=>{
            if(result.status === 200){
              this.setState({details:result.data});                      
            }      
          });      
        }        
        Axios.get(`${process.env.REACT_APP_API_URL}master/getbank`)        
        .then(result=>{
            const options = result.data.map(d => ({
                "value" : d.bankid,
                "label" : d.bankname          
            }))    
            this.setState({banklist: options})             
        });  
    }  
    async handleChange(event) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[event.target.name] = event.target.value;   
        errors[event.target.name] = '';      
        this.setState({details,errors});       
      } 
     
      async selecthandleChange(name,e) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[name] = e.value;   
        errors[name] = '';       
        this.setState({details,errors});      
      }     
      datepickerhandleChange(name,e){
        let details = this.state.details;
        details[name] = e.format('DD-MM-YYYY');
        this.setState({details});
      }    
    render() {
        return (
            <div className="box-body">
                <form>
                    <div className="col-md-12">
                        <div className="col-md-6">
						    <div className="form-group">
                                <label>Issue Date.</label>
                                <DatePicker 
                                      timeFormat={false}
                                      onChange={this.datepickerhandleChange.bind(this,'issue_date')}
                                      dateFormat="DD-MM-YYYY" 
                                      selected={this.state.details.issue_date}
                                      value={this.state.details.issue_date || ''} 
                                      closeOnSelect
                                  /> 
                            </div>
						</div>
                        <div className="col-md-6">
						    <div className="form-group">
                                <label>Amount</label>
				                 <input className="form-control" type="text" name="amount" id="amount" value={this.state.details.amount || ''} onChange={this.handleChange} />
                            </div>						
                         </div>						 
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-6">
						    <div className="form-group">
                                <label>Name of Bank</label>
                                <Select 
                                options={this.state.banklist} 
                                name="bank_id" 
                                value={this.state.banklist.filter(({value}) => value === this.state.details.bank_id)  || '' } 
                                onChange={this.selecthandleChange.bind(this,'bank_id')} 
                                />   
                            </div>
						</div>
                        <div className="col-md-6">
						    <div className="form-group">
                                <label>Branch / City.</label>
				                 <input className="form-control" type="text" name="branch_or_city" value={this.state.details.branch_or_city || ''} onChange={this.handleChange} />
                            </div>						
                         </div>	
                         </div>
                         <div className="col-md-12">  
                        <div className="col-md-6">
						    <div className="form-group">
                                <label>Solvency Details PDF</label>
				                 <input className="form-control" type="file" name="solvency_details_pdf" id="solvency_details_pdf" />							 
                            </div>						
                         </div>							 
                    </div>					
                    <div className="box-footer">
                        <button type="submit" className="btn btn-primary pull-right" name="Update">Save</button>
                    </div>
            </form>
			</div>
        )
    }
}

export default Solveny
